import angular from "angular"

const templateUrl = require("ngtemplate-loader!html-loader!./antecedentes.component.html")

angular.module("fichaAlumnoModule").component("antecedentes", {
  templateUrl: templateUrl,
  bindings: {
    alumno: "<",
    desercion: "<",
    decil: "<",
    updateEstadoMatricula: "<"
  },

  controller: function AntecedentesController(fichaAlumnoService) {
    var self = this

    self.$onInit = function() {
      fichaAlumnoService.getEstadoMatriculas().then(function(data) {
        self.estados = data

        self.$onChanges = function(data) {
          if (data["updateEstadoMatricula"]) {
            self.setEstadoMatricula()
          }
        }

        self.setEstadoMatricula()

        self.selectedEstado = "" + self.alumno.estado_matricula_id
      })
    }

    self.setEstadoMatricula = function() {
      self.estadoMatricula = ""

      for (var i = 0; i < self.estados.length; i++) {
        if (self.estados[i].id === self.alumno.estado_matricula_id) {
          self.estadoMatricula = self.estados[i].nombre
          break
        }
      }
    }

    self.indicadores = {
      desercion: {
        type: "percent",
        class: "kpi",
        title: "Riesgo Deserción",
        value: self.desercion
      },
      exito: {
        type: "number",
        class: "kpi",
        title: "Decil de Riesgo",
        value: self.decil
      },
      alertas: {
        type: "number",
        class: "system",
        title: "Alertas Activas",
        value: 2
      },
      pendientes: {
        type: "number",
        class: "system",
        title: "Atención Pendiente",
        value: 1
      }
    }
  }
})
